import React, { useMemo } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

interface EmptyPageProps {
  src?: string;
  text?: string | React.ReactNode;
  textColor?: string;
  fontSize?: number;
  style?: React.CSSProperties;
}

const EmptyPage = ({ src = '/images/no-data.png', text }: EmptyPageProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container)}>
      <div className={styles.content}>
        {/* <img src={src} className={styles.imgItem} alt='Empty' loading="lazy" /> */}

        <Image
          className={styles.imgItem}
          src={src}
          alt="Empty"
          loading="lazy"
          width={80}
          height={80}
          layout="responsive"
        />
        <span className={styles.titleItem}>{text || t('emptyData')}</span>
      </div>
    </div>
  );
};

export default EmptyPage;
